export enum AnalyticsTrackId {
  "TransactionRecapTimelineEntry.connectAccountsButton" = "TransactionRecapTimelineEntry.connectAccountsButton",
  "SpendingCalendarTimelineEntry.connectAccountsButton" = "SpendingCalendarTimelineEntry.connectAccountsButton",
  "MonthlyCashflowTimelineEntry.connectAccountsButton" = "MonthlyCashflowTimelineEntry.connectAccountsButton",
}
